
import Vue from "vue";
import { mapFields } from "vuex-map-fields";
import { AssistansErsattningOptions } from "@/store/types";
import { AssistansErsattningText } from "@/store/map";
import SammanstallningField from "@/components/Kontaktuppgifter/SammanstallningField.vue";
import AssistansErsattningSammanstallning from "./AssistansErsattningSammanstallning.vue";
import FelaktigAssistansGemensamSammanstallning from "./FelaktigAssistansGemensamSammanstallning.vue";
import FelaktigRedovisningSammanstallning from "./FelaktigRedovisningSammanstallning.vue";
import LatsasBehovSammanstallning from "./LatsasBehovSammanstallning.vue";

export default Vue.extend({
    name: "FelaktigAssistansSammanstallning",
    components: {
        AssistansErsattningSammanstallning,
        FelaktigAssistansGemensamSammanstallning,
        FelaktigRedovisningSammanstallning,
        LatsasBehovSammanstallning,
        SammanstallningField,
    },
    data: () => ({
        AssistansErsattningOptions,
        AssistansErsattningText,
    }),
    computed: {
        ...mapFields(["observationer.assistansErsattning.assistansErsattningVal"]),
    },
});
